import { WebsocketState } from 'types/custom/websocket';
import {
  SET_LOGGED_IN_USER_IDS,
  SET_ORDER_PNL,
  SET_PNL,
  SET_PREPARE_DATA_PROGRESS,
  SET_RECOMMENDATIONS,
  SET_SUBSCRIBED,
  SET_USER_ACCOUNT,
  TOGGLE_ORDER_REQUEST_STATUS,
  TOGGLE_ORDER_STATUS,
  TOGGLE_USER_STATUS
} from './actions';

export const initialState: WebsocketState = {
  livePnl: [],
  orderStatusChanged: false,
  userStatusChanged: false,
  userAccounts: null,
  loggedInUserIds: [],
  orderRequestStatus: false,
  prepareDataProgress: 0,
  orderPnl: {},
  subscribed: false,
  recommendation: false
};

const websocketReducer = (state: WebsocketState, action: any) => {
  switch (action.type) {
    case SET_ORDER_PNL: {
      return {
        ...state,
        orderPnl: action?.payload?.orderPnl
      };
    }
    case SET_PNL:
      return {
        ...state,
        livePnl: action.payload
      };
    case TOGGLE_ORDER_STATUS: {
      let newState = {
        ...state,
        orderStatusChanged: !state.orderStatusChanged
      };

      return newState;
    }
    case TOGGLE_ORDER_REQUEST_STATUS: {
      return {
        ...state,
        orderRequestStatus: !state.orderRequestStatus
      };
    }
    case TOGGLE_USER_STATUS: {
      return {
        ...state,
        userStatusChanged: !state.userStatusChanged
      };
    }
    case SET_USER_ACCOUNT: {
      return {
        ...state,
        userAccounts: {
          ...state.userAccounts,
          [action.payload.userId]: action.payload
        }
      };
    }
    case SET_LOGGED_IN_USER_IDS: {
      return {
        ...state,
        loggedInUserIds: action.payload
      };
    }
    case SET_PREPARE_DATA_PROGRESS: {
      return {
        ...state,
        prepareDataProgress: action.payload
      };
    }
    case SET_SUBSCRIBED: {
      return {
        ...state,
        subscribed: !state.subscribed
      };
    }
    case SET_RECOMMENDATIONS: {
      return {
        ...state,
        recommendation: !state.recommendation
      };
    }
    default:
      return state;
  }
};

export default websocketReducer;
